<template>
  <div class="pollingRecord-container">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20">
          <el-col :span="11">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="queryForm.startTime"
              placeholder="开始时间"
              style="width: 100%"
              :picker-options="startDatePicker"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">—</el-col>
          <el-col :span="11">
            <el-date-picker
              type="date"
              v-model="queryForm.endTime"
              value-format="yyyy-MM-dd"
              placeholder="结束时间"
              style="width: 100%"
              :picker-options="endDatePicker"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item class="r-20" prop="pollintor">
          <el-input
            v-model="queryForm.pollintor"
            @keyup.enter.native="query"
            placeholder="巡检人员"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="sysType">
          <el-select
            class="borderType"
            v-model="queryForm.pollingPoints"
            placeholder="巡检监测点"
          >
            <el-option
              v-for="item in pollingPoints"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">取消</el-button>
      </div>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
    >
      <el-table-column width="24" style="padding: 0"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="time" label="巡检时间" min-width="100"></el-table-column>
      <el-table-column
        prop="pollintor"
        label="巡检人员"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="stationName"
        label="巡检监测点"
        min-width="290"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="所属乡镇、村"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="pollingPeriod"
        label="巡检周期"
        min-width="70"
      ></el-table-column>
      <el-table-column
        prop="lastPollingTime"
        label="上次巡检时间"
        min-width="100"
      ></el-table-column>
      <el-table-column label="操作" min-width="130" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="details(scope.row)">巡检详情</el-button>
          <el-button type="text" @click="track(scope.row)">巡检轨迹</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <el-pagination
      @current-change="handleSizeChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout=" prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <!-- 巡检详情模态框 -->
    <el-dialog
      class="details-dialog"
      :visible.sync="detailsDialog"
      :show-close="false"
      width="76%"
    >
      <!-- 自定义标题栏 -->
      <div slot="title" class="dialog-title">
        <span>{{ dialogTitle }}</span>
        <i class="el-icon-close" @click="detailsDialog = false"></i>
      </div>

      <div class="dialog-content">
        <el-row class="row">
          <div class="content-title">监测点基本信息</div>
          <el-row class="spacer">
            <el-col :span="12">
              <el-row>
                <span class="required">监测点编号</span>
                <span class="text">{{ detailsData.pointNum }}</span>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <span class="required">监测点名称</span>
                <span class="text">{{ detailsData.stationName }}</span>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="spacer">
            <el-col :span="12">
              <el-row>
                <span class="required">监测点类型</span>
                <span class="text">{{ detailsData.type }}</span>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <span class="required">巡检周期</span>
                <span class="text">{{ detailsData.pollingPeriod }}</span>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="spacer">
            <el-col :span="12">
              <el-row>
                <span class="required">经度</span>
                <span class="text">{{ detailsData.longitude }}</span>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <span class="required">纬度</span>
                <span class="text">{{ detailsData.latitude }}</span>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="spacer">
            <el-col :span="12">
              <el-row>
                <span class="required">地理位置</span>
                <span class="text">{{ detailsData.address }}</span>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <span class="required">高程</span>
                <span class="text">{{ detailsData.height }}</span>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="rows">
          <div class="content-title">巡检详情</div>
          <el-row class="spacer">
            <el-col :span="4" align="center" class="tableTypeB">巡检时间</el-col>
            <el-col :span="4" align="center" class="tableType">{{
              detailsData.time
            }}</el-col>
            <el-col :span="4" align="center" class="tableTypeB">巡检人员</el-col>
            <el-col :span="4" align="center" class="tableType">{{
              detailsData.pollintor
            }}</el-col>
            <el-col :span="4" align="center" class="tableTypeB">上次巡检时间</el-col>
            <el-col :span="4" align="center" class="tableTypeLast">{{
              detailsData.lastPollingTime
            }}</el-col>
          </el-row>
        </el-row>

        <!-- 雨量计表格 -->
        <div class="table-device" v-for="item in deviceTable" :key="item.id">
          <el-row class="device-title">
            <el-image
              style="width: 24px; height: 24px; margin-right: 10px"
              :src="require('@/assets/images/geological/polling/' + item.markerImage)"
            ></el-image>
            <span style="font-weight: bold">{{ item.name }}</span>
          </el-row>
          <el-row class="device-bg">
            <el-col :span="7" class="left">
              <el-row>设备编号：{{ item.deviceNum }}</el-row>
              <el-row>检测类型：{{ item.type }}</el-row>
              <el-row>建设单位：{{ item.constructionUnit }}</el-row>
              <el-row>维护单位：{{ item.maintenanceUnit }}</el-row>
              <el-row>设备经度：{{ item.longitude }}</el-row>
              <el-row>设备纬度：{{ item.latitude }}</el-row>
            </el-col>
            <el-col :span="17">
              <el-table
                ref="detailsTable"
                :data="item.children"
                :span-method="arraySpanMethod"
                style="height: 164px"
                size="mini"
              >
                <el-table-column label="检查项目" min-width="170" prop="project">
                </el-table-column>
                <el-table-column label="是否正常" min-width="64" prop="sure">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 16px; height: 16px"
                      :src="require('@/assets/images/geological/' + scope.row.sureImg)"
                    ></el-image>
                  </template>
                </el-table-column>
                <el-table-column
                  label="是否处理"
                  min-width="64"
                  prop="handle"
                ></el-table-column>
                <el-table-column label="巡检前照片" align="center" min-width="180">
                  <template slot-scope="scope">
                    <el-image
                      fit="cover"
                      style="width: 70px; height: 56px"
                      class="urlImg"
                      :src="
                        require('@/assets/images/geological/' +
                          scope.row.beforeImg +
                          '.png')
                      "
                      :preview-src-list="[
                        require('@/assets/images/geological/' +
                          scope.row.beforeImg +
                          '.png'),
                      ]"
                    ></el-image>
                    <div class="badge-text" @click="link(scope.row, 'before', item)">
                      全景图
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="巡检后照片" min-width="180">
                  <template slot-scope="scope">
                    <el-image
                      fit="cover"
                      class="urlImg"
                      style="width: 70px; height: 56px"
                      :src="
                        require('@/assets/images/geological/' +
                          scope.row.afterImg +
                          '.png')
                      "
                      :preview-src-list="[
                        require('@/assets/images/geological/' +
                          scope.row.afterImg +
                          '.png'),
                      ]"
                    ></el-image>
                    <div class="badge-text" @click="link(scope.row, 'after', item)">
                      全景图
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="panorama" width="80%" title="全景图" :visible.sync="innerVisible">
      <div class="dialog-details">
        <div class="item">设备编号：{{ linkData.deviceNum }}</div>
        <br />
        <div class="item">监测类型：{{ linkData.type }}</div>
        <br />
        <div class="item">建设单位：{{ linkData.constructionUnit }}</div>
        <br />
        <div class="item">维护单位：{{ linkData.maintenanceUnit }}</div>
        <br />
        <div class="item">设备经度：{{ linkData.longitude }}</div>
        <br />
        <div class="item">设备纬度：{{ linkData.latitude }}</div>
      </div>
      <iframe v-if="linkUrl" :src="linkUrl" frameborder="0" class="dialog-label"></iframe>
    </el-dialog>

    <!-- 巡检轨迹模态框 -->
    <el-dialog class="trackDialog" :visible.sync="trackDialog" :show-close="false">
      <!-- 自定义标题栏 -->
      <div slot="title" class="dialog-title">
        <span>{{ dialogTitle }}</span>
        <i class="el-icon-close" @click="trackDialog = false"></i>
      </div>
      <Polling-track :location="location" :isActive="isActive"></Polling-track>
    </el-dialog>
  </div>
</template>

<script>
import PollingTrack from "@/components/PollingTrack.vue";
import data from "../../OtherServices/GeologicalMonitor/data.json";
export default {
  name: "PollingRecord",
  components: { PollingTrack },
  data() {
    return {
      queryForm: {
        startTime: "",
        endTime: "",
        pollintor: "",
        pollingPoints: "西湖区转塘街道龙门坎村杨家外里风险防范区",
      },
      pollingPoints: [{ id: 1, label: "西湖区转塘街道龙门坎村杨家外里风险防范区" }],
      isActive: "baseMap",
      tableData: [],
      deviceTable: [],
      location: [],
      dialogTitle: "",
      detailsData: [],
      detailsDialog: false,
      trackDialog: false,
      total: 300,
      currentPage: 1,
      limit: 10,
      startDatePicker: this.expireTimeOptionStart(),
      endDatePicker: this.expireTimeOptionEnd(),
      innerVisible: false,
      linkUrl: "",
      linkData: {},
      evaluatePictureList: [],
    };
  },
  mounted() {
    this.getPollingRecord();
  },
  methods: {
    // 点击图片，大图预览图片
    clickevaluatePicture(row, type) {
      if (type === "before") {
        this.evaluatePictureList = [
          require("@/assets/images/geological/" + row.beforeImg + ".png"),
        ];
      } else if (type === "after") {
        this.evaluatePictureList = [
          require("@/assets/images/geological/" + row.afterImg + ".png"),
        ];

        // this.evaluatePictureList = [afterUrl];
      }
    },
    // 全景图跳转
    link(row, type, item) {
      this.linkData = item;
      if (!row.beforeUrl) {
        this.$message.warning("无全景图数据");
      } else {
        this.innerVisible = true;
        if (type === "before") {
          this.linkUrl = row.beforeUrl;
        } else if (type === "after") {
          this.linkUrl = row.afterUrl;
        }
      }
    },
    // 合并单元格
    arraySpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 3 || columnIndex === 4) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    expireTimeOptionStart() {
      // 当结束时间不为空时，开始时间早于结束时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.endTime) {
            return time.getTime() > new Date(this.queryForm.endTime).getTime();
          } else {
            return time.getTime() > Date.now(); //结束时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    expireTimeOptionEnd() {
      // 当开始时间不为空时，结束时间要晚于开始时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.startTime) {
            return (
              time.getTime() < new Date(this.queryForm.startTime).getTime() - 8.64e7 ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    // 当前页数改变时触发
    handleSizeChange(val) {
      console.log("当前页数是：", val);
      this.currentPage = val;
    },

    // 选择要显示的地图样式
    choiceMapStyle() {
      console.log("choiceMapStyle");
    },
    // 点击表格的某一行
    //  handleClickTableRow(row, event, column) {
    //    console.log(row, event, column);
    //  },
    //  巡检详情
    details(row) {
      // console.log(row);
      this.dialogTitle = "巡检详情";
      this.detailsDialog = true;
      this.detailsData = row;
      this.deviceTable = row.deviceTable;
    },
    //  巡检轨迹
    track(row) {
      this.trackDialog = true;
      this.dialogTitle = "巡检轨迹";
      this.location = row.location;
    },
    //  查询按钮
    query() {
      console.log(this.queryForm);
      this.getPollingRecord();
    },
    //  取消按钮（重置表单数据）
    reset() {
      this.$resetForm(this, "queryForm");
      this.getPollingRecord();
    },
    //  获取表格数据
    async getPollingRecord() {
      let obj = {};
      obj.startTime = this.queryForm.startTime;
      obj.endTime = this.queryForm.endTime;
      obj.pollingPoints = this.queryForm.pollingPoints;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      // console.log(obj);
      // let { data: res } = await this.$axios.get("/api/vehicle/list/V2", {
      //   params: obj,
      // });
      // if (res.code == 1) {
      //   this.tableData = res.data.list;
      //   this.total = res.data.totalCount;
      //   this.currentPage = res.data.currPage;
      // }
      this.tableData = data.tableData;
      // this.deviceTable = data.deviceTable;
    },
  },
};
</script>

<style lang="scss" scoped>
.pollingRecord-container {
  margin: 10px;
  background: #fff;
  padding: 20px;
  height: calc(100% - 80px);
  overflow-y: hidden;
  .line {
    color: #ccc;
    text-align: center;
  }
  .details-dialog {
    font-size: 14px;
    overflow-y: auto;
    .dialog-content {
      .row {
        padding-bottom: 20px;
      }
      .content-title {
        padding-left: 10px;
        font-weight: 600;
        color: #333;
        border-left: 4px solid #108ee9;
      }
      .spacer {
        color: #1e1e1e;
        padding: 10px 0 0 14px;
        .required {
          display: inline-block;
          align-items: flex-start;
          width: 102px;
          box-sizing: border-box;
        }
        .required::after {
          content: "*";
          color: #ff0000;
          margin-right: 4px;
          margin-top: 6px;
        }
        .tableType {
          line-height: 28px;
          border: 1px solid #333;
          border-right: none;
        }
        .tableTypeB {
          line-height: 28px;
          border: 1px solid #333;
          border-right: none;
          background: #ddeffd;
        }
        .tableTypeLast {
          line-height: 28px;
          border: 1px solid #333;
        }
      }
      .rows {
        padding-bottom: 10px;
      }
      .table-device {
        height: 193px;
        color: #333;
        padding-left: 14px;
        padding-bottom: 10px;
        .device-title {
          display: flex;
          align-items: center;
          padding-left: 20px;
          height: 32px;
          background: #d7d7d7;
        }
        .device-bg {
          height: 164px;
          background: #f2f2f2;
          .left {
            padding: 10px !important;
            height: 100%;
            .el-row {
              padding-bottom: 6px;
            }
            :last-child {
              padding-bottom: 0;
            }
          }
          .badge-text {
            padding-left: 24px;
            color: #108ee9;
            text-decoration-line: underline;
            cursor: pointer;
          }
          .urlImg {
            cursor: pointer;
          }
        }
        ::v-deep .el-badge__content {
          width: 14px;
          height: 14px;
          line-height: 14px;
          padding: 0;
          border-radius: 0;
          background-color: #199ed8;
        }
        ::v-deep .el-table {
          margin-bottom: 10px;
          border-right: 1px solid #797979;
          border-bottom: 1px solid #797979;
        }
        ::v-deep .el-table table .cell {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          min-height: 30px;
        }
        ::v-deep .el-table th {
          background-color: #ddeffd;
          padding: 0;
          border: 1px solid #797979;
          border-right: none;
          border-bottom: none;
        }
        ::v-deep .el-table td,
        .el-table th.is-leaf {
          border: 1px solid #797979;
          border-right: none;
          border-bottom: none;
        }
        ::v-deep .el-table--mini td {
          height: 30px;
          padding: 0;
        }
      }
    }
  }
  //   ::v-deep .borderType input::-webkit-input-placeholder {
  //     /* WebKit browsers 适配谷歌 */
  //     color: #333;
  //   }
  //   ::v-deep .borderType input:-moz-placeholder {
  //     /* Mozilla Firefox 4 to 18 适配火狐 */
  //     color: #333;
  //   }
  //   ::v-deep .borderType input::-moz-placeholder {
  //     /* Mozilla Firefox 19+ 适配火狐 */
  //     color: #333;
  //   }
  //   ::v-deep .borderType input:-ms-input-placeholder {
  //     /* Internet Explorer 10+  适配ie*/
  //     color: #333;
  //   }
  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    padding-right: 20px;
  }
  .el-icon-close {
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
  ::v-deep .panorama .el-dialog {
    min-width: 1076px;
    margin-top: 5vh !important;
    height: 84vh;
    .el-dialog__body {
      padding: 0 !important;
      .dialog-label {
        display: block;
        width: 100%;
        height: 84vh;
      }
      .dialog-details {
        position: absolute;
        top: 100px;
        left: 10px;
        height: 60%;
        font-size: 14px;
        color: #333;
        .item {
          display: inline-block;
          background: #ccc;
          opacity: 0.8;
          margin-bottom: 6px !important;
        }
      }
    }
  }

  ::v-deep .el-input__prefix {
    left: auto;
    right: 10px;
    color: #333;
  }
  ::v-deep .el-icon-arrow-up:before {
    font-weight: 600;
    color: #333;
  }
  ::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #333 !important;
  }
  ::v-deep .el-select .el-input__inner:focus {
    border-color: #333 !important;
  }
  ::v-deep .el-input__inner {
    padding-left: 15px;
  }
  ::v-deep .details-dialog .el-dialog {
    min-width: 1054px;
    margin-top: 12vh !important;
    .el-dialog__body {
      padding: 10px 20px 140px;
      overflow-y: auto;
      height: 64vh;
    }
  }
  ::v-deep .trackDialog .el-dialog {
    min-width: 1200px;
    width: 84vw;
    margin-top: 12vh !important;
    height: 84vh;
    .el-dialog__body {
      padding: 0;
    }
  }
  ::v-deep .el-icon-circle-close:before {
    color: #fff;
  }
}
</style>
